import { getAllAltForms } from "../../../../config"
import { type Pkm, PkmIndex } from "../../../../types/enum/Pokemon"
import type { IPokemonCollectionItemUnpacked } from "../../../../types/interfaces/UserMetadata"

type PokemonCollection = ReadonlyMap<string, IPokemonCollectionItemUnpacked>

/**
 * Alternative forms share one Pokédex entry. A family counts as played when
 * its base form or any of its alternative forms has been played.
 */
export function hasPokemonFamilyBeenPlayed(
  pokemon: Pkm,
  collection: PokemonCollection | undefined
): boolean {
  return getAllAltForms(pokemon).some(
    (form) => (collection?.get(PkmIndex[form])?.played ?? 0) > 0
  )
}
